import { createFileRoute } from "@tanstack/react-router";

import Writers from "@/features/writers/Writers";

export const Route = createFileRoute("/_auth/writers/")({
  component: Writers,
});
